export default __webpack_public_path__ + "7441e7cedaec9a1cc5249017f984207a.png";